<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "tariffs",
    cardSetLink: "tariffs",
    item: null,
    fields: [
      {
        col: " col-12 col-md-12",
        key: "type",
        label: "Тип",
        type: "static_radio",
        items: [
          { id: "month", title: "По месяцам" },
          { id: "count", title: "По урокам" },
        ],
      },

      {
        key: "title",
        label: "Название",
        isMultiLang: true,
        type: "field",
      },
      {
        key: "description",
        label: "Краткое описание",
        isMultiLang: true,
        type: "textarea",
      },

      {
        key: "period",
        label: "Количество",
        type: "field",
        textType: "number",
      },
      {
        key: "price",
        label: "Стоимость",
        type: "field",
        textType: "number",
      },
      // {
      //   key: "client_count",
      //   label: "Количество детей",
      //   type: "field",
      //   textType: "number",
      // },
      {
        key: "is_active",
        label: "Активность",
        type: "checkbox",
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
